import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkTranscriptionCompromisedAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_TRANSCRIPTION_COMPROMISED_AUDIO_RECORDING";
  }

  // Transcription compromised doesn't change model status fields
  // The event is tracked for observability purposes
}
